<template>
<div v-if="orderInfo">

    <headerNav title="订单详情" />
    <!-- <van-steps :active="active">
            <van-step>提交订单</van-step>
            <van-step>配送中</van-step>
            <van-step>交易完成</van-step>
        </van-steps> -->

    <!-- <van-cell class="logistics" to="/user/order/logistics/1" title="您的订单已由本人签收（已在配送员处采用无纸化方式签收本订单）。感谢您在京东购物，欢迎再次光临。参加评价还能赢取京豆哟。" label="2018-08-31 21:04:03" icon="logistics" is-link /> -->
    <div class="omain">
        <div class="info">
            <van-cell-group>
                <van-cell center v-if="orderInfo.logisticsNo || orderInfo.sublogisticInfos">
                    <template>
                        <div class="info-logistic">
                            <van-icon class="info-icon info-logistic-icon-left" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon" name="yifahuo" />
                            <div>快递单号</div>
                            <div>{{orderInfo.logisticsNo}} </div>
                            <van-icon class="info-icon info-logistic-icon-right" :size="$abctheme.fontbig" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
                        </div>
                        <div class="info-logistic" v-for="item in orderInfo.sublogisticInfos" :key="item.tid">
                            <van-icon class="info-icon info-logistic-icon-left" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon" name="yifahuo" />
                            <div>快递单号</div>
                            <div>{{item.logisticsNo}} </div>
                            <van-icon class="info-icon info-logistic-icon-right" :size="$abctheme.fontbig" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
                        </div>
                    </template>
                </van-cell>
                <van-cell center>
                    <template>
                        <div class="info-address">
                            <van-icon class="info-icon info-logistic-icon-left" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon" name="dizhi" />
                            <div>{{orderInfo.receiverName+" "+orderInfo.receiverMobile}}<van-button size="mini" class="mcbtn" v-clipboard:copy="orderInfo.receiverMobile" v-clipboard:success="onCopy" v-clipboard:error="onError">复制手机号码</van-button></div>
                            <div>{{orderInfo.receiverState+" "+orderInfo.receiverCity+" "+orderInfo.receiverDistrict+" "+setdetailaddress(orderInfo)}} </div>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
        </div>

        <div class="info">
            <van-cell-group class="total">
                <van-row class="currow">
                    <van-col span="16">{{'订单：'+orderInfo.tid}}</van-col>
                    <van-col span="8" class="curcol">{{orderInfo.deliveryStatus==1?'部分发货':orderInfo.orderStatusEnumName}}</van-col>
                </van-row>
                <!-- <div slot="header">
                    <van-cell class="title" :title="'订单：'+orderInfo.tid" :value="orderInfo.orderStatusEnumName" />
                </div> -->
                <div v-for="(product,i) in orderInfo.tradeDetails" :key="i">
                    <trade-card :product='product' />
                </div>

                <van-cell v-for="(item,index) in orderInfo.tranferTids" :key="index"  :title="item.isCompanyOrder?'转公司单号':'转自发单号'" :value="item.tid" />
                <van-cell title="商品总额" :value="orderInfo.totalFee" />
                <van-cell title="运费" :value="'+'+orderInfo.postFee" />
                <van-cell title="实付金额" :value="orderInfo.payment" style="font-weight: 700;" />
                 <van-cell title="买家备注" :value="orderInfo.buyerMessage" />
            </van-cell-group>
        </div>

        <!-- <div style="height:15px;"></div>
        <van-cell-group>
            <van-cell title="订单编号" value="18081609422771742" />
            <van-cell title="下单时间" value="2018-08-16 09:42:27" />
            <van-cell title="订单状态" value="配送中" />
        </van-cell-group> -->

        <div class="info footer">
            <div v-if="orderInfo.isShowCancel||orderInfo.isShowDeal||orderInfo.isShowSend||orderInfo.isShowPlat" class="munu">
                <!-- <van-button size="small" color="#ff9970" plain round type="primary" v-if="orderInfo.isShowCancel" @click.stop="cancel(item)">取消</van-button> -->
                <van-button size="small" color="#ff9970" plain round type="primary" v-if="orderInfo.isShowDeal" @click.stop="deal(orderInfo)">处理</van-button>
              <!--  <van-button size="small" color="#ff9970" plain round type="primary" v-if="orderInfo.isShowDeal" @click.stop="pay(item)">去付款</van-button> -->
                <van-button size="small" color="#ff9970" plain round type="primary" v-if="orderInfo.isShowSend" @click.stop="send(orderInfo)">发货</van-button>
                <van-button v-if="orderInfo.isShowPlat" size="small" color="#ff9970" plain round type="primary" @click.stop="logisticinfo(orderInfo)">物流轨迹</van-button>
            </div>
        </div>
    </div>
    <van-dialog v-model="dialogshow" @confirm="sendorder" @beforeClose="btnclose"    title="请输入快递信息" show-cancel-button>
        <van-field v-model="sendto.logisticName" label="物流方式" placeholder="请输入物流方式" />
        <van-field v-model="sendto.logisticNo" label="快递单号" placeholder="请输入快递单号" />
    </van-dialog>
</div>
</template>

<script>
import request from "@/config/ajax";

export default {
    data() {
        return {
            dialogshow:false,
            tid: "",
            systemsetting: undefined,
            orderInfo: undefined,
            paydto: {
                tid: "",
            },
            sendto:{
                logisticNo:'',
                tid:'',
                logisticName:''
            }
        };
    },
    created() {
        var option = this.$route.query;
        this.tid = option.tid;
        request
            .post("/api/services/app/SystemSettingFunction/QueryModel")
            .then((x) => {
                this.systemsetting = x.result;
            });
        this.loaddata();
    },
    methods: {
        loaddata() {
            request
                .post("/api/services/app/PhoneTrade/QueryDealModel", {
                    tid: this.tid,
                })
                .then((item) => {
                    this.orderInfo = item.result;
                });
        },
        onCopy(value)
        {
            this.$toast("复制成功");
        },
        onError(e)
        {
            this.$toast("复制失败,原因:"+e);
        },
        pay(item){
            var curtranferorder=item.tranferTids.filter(x=>x.isCompanyOrder);
            if(curtranferorder.length<1)
            {
                Toast('无可付款订单');
                return;
            }
            var tid=curtranferorder[0].tid;
            this.$router.push({
                path: '/pay',
                query: {
                    tid: tid,
                    code:''
                }
            });
        },
        btnclose(action, done){
            if (action === 'confirm') {
                done(false);
            } else {
                done();
            }
        },
        sendorder()
        {
            if(!this.sendto.logisticNo)
            {
                this.$toast('请输入快递单号');
                return;
            }
            this.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '发货中,请稍后',
            });
            
            //需使用推送
            request.post('/api/services/app/PhoneTrade/TranferDeliver', this.sendto).then(x => {
            })
        },
        send(item)
        {
            //先检索 是否有自发订单
            var curtranferorder=item.tranferTids.filter(x=>!x.isCompanyOrder);
            if(curtranferorder.length<1)
            {
                Toast('无可发货订单');
                return;
            }
            
            console.log(item.tranferTids);
            var tid=curtranferorder[0].tid;
            this.sendto.logisticNo='';
            this.sendto.tid=tid;
            this.dialogshow=true;
            //获取当前订单号
        },
        oncepay(item) {
            this.$router.push({
                path: "/pay",
                query: {
                    tid: item.tid,
                },
            });
        },
        sqtk(item) {
            this.paydto.tid = item.tid;
            request
                .post("/api/services/app/PhoneRefund/BuyerRefund", this.paydto)
                .then(() => {
                    this.loaddata();
                });
        },
        cancelOrder(item) {
            this.paydto.tid = item.tid;
            request
                .post("/api/services/app/PhoneTrade/CancelOrder", this.paydto)
                .then(() => {
                    //重新刷新或者替换该条数据
                    //查找两个列表将数据更换掉
                    this.loaddata();
                });
        },
        confirmsend(item) {
            this.paydto.tid = item.tid;
            request
                .post("/api/services/app/PhoneTrade/ConfirmReceiptOrder", this.paydto)
                .then(() => {
                    this.loaddata();
                });
        },
        logisticinfo(item) {
             //找出公司订单
            var mtid= item.tranferTids.filter(x=>x.isCompanyOrder)[0].tid;
            this.$router.push({
                path: '/logisticstrajectory',
                query: {
                    tid: mtid
                }
            });
        },
        setdetailaddress(item) {
            return item.receiverAddress;
            if (item.receiverAddress) {
                var aa = item.receiverAddress;
                if (item.receiverAddress.length > 4) {
                    var aa = item.receiverAddress.substring(0, 4);
                    aa += "****";
                }
                return aa;
            } else {
                return "";
            }
        },
        deal(item)
        {
            this.$router.push({
                path: '/cloundorderdeal',
                query: {
                    tid: item.tid
                }
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.omain {
    position: relative;
    margin: 10px;
    font-size: 14px;
}

.info {
    border-radius: 4px;
    box-shadow: 1px 1px 4px #dcdcdc;
    margin-bottom: 10px;
}

.info-logistic {
    position: relative;
    padding: 0 20px 0 40px;
}

.info-address {
    position: relative;
    padding: 0 20px 0 40px;
}

.info-icon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
}

.info-logistic-icon-right {
    right: 0;
}

.info-logistic-icon-left {
    left: 0;
}

.currow {
    padding: 10px 16px;
    font-size: 14px;
}

.curcol {
    text-align: right;
    color: red;
}

.logistics {
    margin-top: 15px;
}

.logistics i {
    line-height: 60px;
    font-size: 20px;
}

.van-cell__title span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.van-cell__label {
    color: #999;
}

.total {
    font-size: 12px;
}

.total .van-cell__value {
    color: red;
}

.footer {
    position: fixed;
    left: 10px;
    right: 10px;
    border-top: 1px solid #e5e5e5;
    bottom: 0;
    background: #fff;
    line-height: 24px;
    text-align: right;
    padding: 10px 0;
}

.van-button {
    padding: 0px 14px 0 14px;
    height: 28px;
    margin-right: 10px;
}
.mcbtn{
    margin-left:5px;
    border: 4px;
    background-color:rgb(253, 209, 8);
    color:#9665e4;
}
</style>
